import React, {useState, useEffect} from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import { PIFlowLeftNavBar } from '../../ReusableComp/NavBarLeft';
import { useDispatch, useSelector } from 'react-redux';
import InputComponent from '../../ReusableComp/InputComponent';
import { Col,  Row } from 'react-bootstrap';
import { TOGGLE_NO, TOGGLE_YES, base_url } from '../../../utilities';
import axios from '../../../axios-interceptor';
import  PopUpModal, { PopUpAlert } from '../../ReusableComp/PopUpModal';
import { useNavigate } from 'react-router';
import moment from 'moment';
import Loader from '../../ReusableComp/Loader'; // Import the Loader component
import {useLocation} from 'react-router-dom'
import { formatDate } from '../../ReusableComp/dateFormat';
import { convertLength } from '@mui/material/styles/cssUtils';

export default function RejectedSubjEdit() {
  const [open, setOpen] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [loading, setLoading] = useState(false);
 const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const rejSubjDetls = location?.state?.rejSubjDetls

const [dsblFrRejSub, setDsblFrRejSub] = useState(true)
const [error1, setError1] = useState('');
const [werror, setWerror1] = useState('');

const [rejSubj] = useState(rejSubjDetls)

useEffect(() => {
  
}, [rejSubjDetls])


const [firstPgInputs, setFirstPgInputs] = useState({
    first_name:rejSubj?.first_name,
    last_name:rejSubj?.last_name,
    date_of_birth:rejSubj?.date_of_birth
  })



const [study_id, setStudy_id] = useState([])
const [btnDisable, setBtnDisable] = useState(false)
const [regStep, setRegStep] = useState(1);
const [toggleSAE, setToggleSAE] = useState(false);

const piStudyData = useSelector((state) => (state.piStudyList));
const piDetails = useSelector((state) => (state.piDetails));
const subjNumber = useSelector((state) => state.getSubjNum);
const [error, setError] = useState('');


    useEffect(() => {
   

        if(window.location.pathname ==='/subjectregistration' && regStep!==1){
            setBtnDisable(true)
          }else{
              setBtnDisable(false)
          }
        // dispatch(getPIData(localStorage.login_user_id))
        // dispatch(getSAdvEvents())
        // dispatch(getAllOutComes())
        // dispatch(getActionTaken())
        // dispatch(getActionTakenForAE())
        // dispatch(getPiStudies())
        // dispatch(getAllCausalities())
        // dispatch(getStudyTitles(study_id[0]))
        // dispatch(getSubjectNumber(study_id[0]))
       
    }, [dispatch,regStep, localStorage.login_user_id, study_id])
    const [medicationDetails, setMedicationDetails] = useState(
        
        
      rejSubj?.concomitantMedication?.map((i, index) =>({
            "concomitant_medication_id": i.concomitant_medication_id,
            "medication": i.medication,
            "medication_manufacturer": i.medication_manufacturer,
            "medication_batch_number": i.medication_batch_number,
            "medication_route_site": i.medication_route_site,
            "medication_dosage":i.medication_dosage,
            "medication_frequency": i.medication_frequency,
            "current_idx":index
        }))  
        
      
    ); 
    
    const [medUsedInLast3WeeksDetails, setMedUsedInLast3WeeksDetails] = useState(
      rejSubj?.medicationUsedInLast3Weeks === null || rejSubj?.medicationUsedInLast3Weeks === undefined? [{
        "medication_name": "",
        "medication_route": "",
        "dosage":"",
        "frequency": "",
        "current_idx":1
      },]:
      rejSubj?.medicationUsedInLast3Weeks?.map((i, index) => ({
        "subject_medication_used_in_last_3weeks_id": i.subject_medication_used_in_last_3weeks_id||null,
        "dosage":i.dosage,
        "frequency":i.frequency ,
        "medication_name":i.medication_name ,
        "medication_route":i.medication_route ,
        "current_idx":index
       }))
    );
    
const handleSaeToggle=()=>{
  setToggleSAE(!toggleSAE) 
  setDateofOnsetSAE('')
  setSeriousAE('')
  setSearchTerm('')
  setBtnTitle('Select Adverse Criteria')
}


let medicationDtlsBtn = medicationDetails?.some(detail => {
  let indx=detail.current_idx;
  delete detail.current_idx;
  let x= !Object.values(detail).every(value => value!=='')
  detail.current_idx=indx;
  return x
})
        
    let piSiteDetails = piDetails?.pi_sites
    const registrationSteps = [
        {
            stepTitle: "1. Quality Reviewer Comments",
            description:"Comments"
        },
        {
            stepTitle: "2. Subject details",
            description:"Age, Sex, Weight, Phone, etc."
        },
      
        {
            stepTitle: "3. Past health history",
            description:"Allergies, medication etc."
        },
        {
            stepTitle: "4. Dose details",
            description:"Dose 1, Dose 2, etc."
        },
        
        {
            stepTitle: "5. Concomitant Medication",
            description:"Concurrent Medication"
        },
        {
            stepTitle: "6. Preview and Confirm",
            description:"Summary of subject registration"
        },
        
    ];
    const [subjPhone, setSubjPhone] = useState(rejSubj?.phone_number);
    const [age, setAge] = useState(rejSubj?.age);
    const [gender, setGender] = useState(rejSubj?.sex ||'');
    const [weight, setWeight] = useState(rejSubj?.weight)
    const [today, setToday] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [btnTitle, setBtnTitle] = useState("");
    const [height, setHeight] = useState(rejSubj?.height)

    const [seriousAE, setSeriousAE] = useState({});
    const [dateofOnsetSAE, setDateofOnsetSAE] = useState("");
    const [anyAllergies, setAnyAllergies] = useState(rejSubj?.allergies===null?'':rejSubj?.allergies)
    const [medicalHistory, setMedicalHistory] = useState(rejSubj?.medical_history ===null?'':rejSubj?.medical_history)
    const [ConcurrentIllness, setConcurrentIllness] = useState(rejSubj?.concurrent_illness ===null?'':rejSubj?.concurrent_illness)
    const [study, setStudy] = useState(rejSubj?.study_name);
    const [routeOfAdministration, setRouteOfAdministration] = useState(rejSubj?.dose_administration_name)
    const [anatomical, setAnatomical] = useState(rejSubj?.anatomical_site_administration_name)
    const [dateOfAdministration, setDateOfAdministration] = useState(rejSubj?.date_of_administration)
    const [timeOfAdministration, setTimeOfAdministration]=useState(rejSubj?.time_of_administration)
    const [batchNumber, setBatchNumber] = useState(rejSubj?.batch_number)
    const [expiry, setExpiry] = useState(rejSubj?.expiry_date)

    const [dose, setDose] = useState(1);
    const [dateOfManu, setDateOfManu] = useState(rejSubj?.date_of_manufacture)
    const [phoneValidation, setPhoneValidation] = useState(false)



      const minxDate = rejSubj?.study_initiation_date
  ? moment(rejSubj.study_initiation_date).format("YYYY-MM-DD")
  : moment().format("YYYY-MM-DD");
  const currentDate = new Date();
  const range = rejSubj && rejSubj?.age_group?.split('-');
  const minDateOfBirth = new Date(currentDate);
  const maxDateOfBirth = new Date(currentDate);
  let minDob, maxDob
  if(range)
   {
    minDateOfBirth.setFullYear(currentDate.getFullYear() - range[1]);
    maxDateOfBirth.setFullYear(currentDate.getFullYear() - range[0]);
    // minDob = minDateOfBirth.toISOString().split('T')[0]
    // maxDob = maxDateOfBirth.toISOString().split('T')[0]
  } 
    const handleDateOfManuChange = (e) => {
        setDateOfManu(e.target.value);
        };

    const handleExpiryChange = (e) => {
        setExpiry(e.target.value);
        };
 
    const handleBatchNumberChange = (e) => {
        setBatchNumber(e.target.value);
        };



    const handleTimeOfAdministrationChange = (e) => {
      const selectedTime = e.target.value;
      const minTime = '09:00'; 
      const maxTime = '23:59';
      if (selectedTime >= minTime && selectedTime <= maxTime) {
        setTimeOfAdministration(selectedTime);
      } else {
        setTimeOfAdministration(minTime);
      }
        };

    const handleStudyChange = (e) => {
        setStudy(e.target.value);
        };
    
   
    const handleDateOfAdministrationChange = (e) => {
        setDateOfAdministration(e.target.value);
        };

    const handleAllergyChange = (e) => {
        setAnyAllergies(e.target.value);
        
        };



    const handleMedicalHistoryChange = (e) => {
        setMedicalHistory(e.target.value);
        };
    const handleConcurrentIllnessChange = (e) => {
        setConcurrentIllness(e.target.value);
        };
    
 
 
const [searchTerm, setSearchTerm] = useState("");

    const handleInputChange = (index, e) => {
        const { name, value } = e.target;
        const newArray = [...medicationDetails];
        newArray[index][name] = value;
        setMedicationDetails(newArray); 
       
      };

      const [currentIndex, setCurrentIndex] = useState(1);
      const handleAddFields = () => {
        if(medicationDetails != undefined) {
          setMedicationDetails([...medicationDetails, 
            {
                "concomitant_medication_id": null,
                "medication": null,
                "medication_manufacturer": null,
                "medication_batch_number": null,
                "medication_route_site": null,
                "medication_dosage":null,
                "medication_frequency": null,
                "current_idx":currentIndex+1
            },]);

        }else{

          setMedicationDetails([ 
            {
                "concomitant_medication_id": null,
                "medication": null,
                "medication_manufacturer": null,
                "medication_batch_number": null,
                "medication_route_site": null,
                "medication_dosage":null,
                "medication_frequency": null,
                "current_idx":currentIndex+1
            },]);
        }
        
       
            setCurrentIndex(currentIndex + 1);
      };

      const handleDeleteFields = (index) => {
        let updatedData = [...medicationDetails]
        updatedData?.map((elemObj,i)=>{
          if(elemObj.current_idx==index.current_idx){
            updatedData.splice(i,1)
          }
        })

        
        setMedicationDetails(updatedData)
        
      }

    
      


      const selectedStudy = (id, option)=>{
         if(id){
            setStudy_id(id)
        }
      }
    useEffect(() => {
        
    const currentDate = new Date();
    const formattedDate = currentDate.toDateString();
    setToday(formattedDate);
    }, []);
    const handleStepChange = (val) => {
        if(val > 0 && regStep < registrationSteps.length + 1){
            let shift = regStep + val
            setRegStep(shift);
        }
        if(val < 0 && regStep > 1){
            let shift = regStep + val
            setRegStep(shift);
        }
        
    }
 
    const handleQrGenderChange = (val) => {
        setGender(val);
        };
 
 



const handleFirstPage =(e)=>{
  const { name, value } = e.target;
  const regex = /^[A-Za-z\s]+$/;  
  if (name === "date_of_birth") {
    calculateAge(value)
  }



  if(name==='first_name' || name ==='last_name'){
    if (regex.test(value) || value === '') {
      setFirstPgInputs((prev =>({
        ...prev,
        [name]:value,
      })))
    }
  }
  else{setFirstPgInputs((prev =>({
    ...prev,
    [name]:value,
  })))}

}
 

// const firstDisable = Object.keys(firstPgInputs)
// .map((key) => firstPgInputs[key])
// .every((value) => value !== '');


  const weightInKg = rejSubj?.weight;
  const heightInM = rejSubj?.height / 100; 

  const defaultBmi = (weightInKg / (heightInM * heightInM)).toFixed(2);


  const [bmi, setBMI] = useState(defaultBmi);



const calculateBMI = (weight, height) => {
  if (weight && height) {
    const weightKg = parseFloat(weight);
    const heightM = parseFloat(height) / 100; 
    const bmiValue = (weightKg / (heightM * heightM)).toFixed(1);
    setBMI(bmiValue);
  } else {
    setBMI('');
  }
};
 
 
    const handleWeightChange = (e) => {
      const{value} = e.target;
      const regex = /^[+]?([0-9]+(?:[\.][1-9]*)?|\.[1-9])$/;
      if ((regex.test(value) || value === '') && parseFloat(value) <= 250) {
        setWeight(value)
        calculateBMI(value, height);
        setWerror1(null);
      } else if (e.nativeEvent.inputType === "deleteContentBackward") {
        const truncatedValue = value.slice(0, -1); 
        setWeight(value)
        calculateBMI(value, height);
        setWerror1(null);
      } else {
        setWerror1("Weight cannot exceed 250kg");
      
      }
       
    }

    const handleHeightChange = (e) => {
      const{value} = e.target;
      const regex = /^[+]?([0-9]+(?:[\.][1-9]*)?|\.[1-9])$/;
      if ((regex.test(value) || value === '') && parseFloat(value) <= 250) {
        setHeight(value);
        calculateBMI(weight, value);
        setError1(null);
      } else if (e.nativeEvent.inputType === "deleteContentBackward") {
        const truncatedValue = value.slice(0, -1); 
        setHeight(truncatedValue);
        calculateBMI(weight, truncatedValue);
        setError1(null);
      } else {
        setError1("Height cannot exceed 250cm");
      
      }
       
    }
   

    const calculateAge = (dateOfBirth) => {
        const today = new Date();
        const birthDate = new Date(dateOfBirth);
        let calculatedAge = today.getFullYear() - birthDate.getFullYear();
    
        if (
            today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() &&
            today.getDate() < birthDate.getDate())
        ) {
            calculatedAge--;
        }
    
        setAge(calculatedAge);
        };
    
window.onkeydown = keypress;
function keypress(event) {
    if (event.keyCode == 27) {
        setShowPopup(false);
    }
}

const handleNavigateNext =()=>{
   
    handleStepChange(1)
}
 
 
const [eventDesc, setEventDesc] = useState()
const [valuForDisble, setValuForDisble] = useState()
 
const [alertMessage, setAlrtMessage] = useState('')

const handleClosePopup = () => {
  setOpen(false);
};
const handleDonePopup = () => {
  setOpen(false);
  setTimeout(() => {
    // window.location.reload();
    // navigate('/rejectedsubjects')
  }, 200);
};
const handleReviewActions = () => {
  setOpen(false);
//
if(updatedObj.concomitant_medication !=null || updatedObj.concomitant_medication !=undefined){
if(updatedObj.concomitant_medication?.length>0){
  updatedObj.is_concomitant_medication=1
}
}
  setIsbtnDisabled(true)
    setLoading(true);
    axios
    .post(base_url + 
      "subjects/update_subject", updatedObj)
    .then((res) => {
      // return null
      setIsbtnDisabled(false)
      if(res.data.message ==='Subject updated successfully'){
        setLoading(false);
      setOpenModal(true) }
      else{
        alert('Some thing went wrong')
        setTimeout(() => {
          navigate('/rejectedsubjects')
        }, 500);
      }
    }) .catch((error) => {
      setIsbtnDisabled(false)
      setLoading(false);
         console.log(error)
      });

}

const handleModalConfirm=()=>{
  setOpenModal(false)
  setTimeout(() =>{
    navigate('/rejectedsubjects')
  },200)
}
const [cancelBtn, setCancelBtn] = useState(false)
 const handleEditFields =()=>{
    setDsblFrRejSub(false)
    setCancelBtn(true)
    // setPhoneValidation(true)
 }

 const handleCancelFields =()=>{
  setMedUsedInLast3WeeksRadio("no")
    setDsblFrRejSub(true)
    setCancelBtn(false)
    firstPgInputs.date_of_birth = rejSubj?.date_of_birth
    setWeight(rejSubj?.weight)
    setSubjPhone(rejSubj?.phone_number)
    setAnyAllergies(rejSubj?.allergies===null?'-':rejSubj?.allergies)
    setMedicalHistory(rejSubj?.medical_history ===null?'-':rejSubj?.medical_history)
    setConcurrentIllness(rejSubj?.concurrent_illness ===null?'-':rejSubj?.concurrent_illness)
    setDateOfAdministration(rejSubj?.date_of_administration)
    setTimeOfAdministration(rejSubj?.time_of_administration)
    setBatchNumber(rejSubj?.batch_number)
    setExpiry(rejSubj?.expiry_date)
    setDateOfManu(rejSubj?.date_of_manufacture)
    setGender(rejSubj?.sex)
    setBMI(defaultBmi)
    setHeight(rejSubj?.height)

    setMedicationDetails(rejSubj?.concomitantMedication?.map((i, index) =>({
        "concomitant_medication_id": i.concomitant_medication_id||null,
        "medication": i.medication,
        "medication_manufacturer": i.medication_manufacturer,
        "medication_batch_number": i.medication_batch_number,
        "medication_route_site": i.medication_route_site,
        "medication_dosage":i.medication_dosage,
        "medication_frequency": i.medication_frequency,
        "current_idx":index
    }))  )

    setMedUsedInLast3WeeksDetails(rejSubj?.medicationUsedInLast3Weeks?.map((i, index) => ({
      "subject_medication_used_in_last_3weeks_id": i.subject_medication_used_in_last_3weeks_id||null,
      "dosage":i.dosage,
      "frequency":i.frequency ,
      "medication_name":i.medication_name ,
      "medication_route":i.medication_route ,
    })))
 }
 
const [isbtnDisabled, setIsbtnDisabled] = useState(false);
const handelSubjectCreate =()=>{
    setAlrtMessage("Are you sure you want to update?")
    setOpen(true)
    
  }

  // const mintime = 
 const handlePhonenumber=(e)=>{
  let value= e.target.value
  
    setSubjPhone(value.length>10?value.slice(0,10):value)
    setPhoneValidation(value.length >= 10? false :true)
    if (value.length <= 10) {
      setSubjPhone(value);
      setError(value.length === 10 || value.length === 0 ? '' : '* Must be 10 digits');
    }
 }
 
  const maxDate = new Date().toISOString().split('T')[0];
  const JustBtwn = "d-flex justify-content-between";
  const next = "orange_btn px-md-4 py-md-2";
    

function handleBackAction() {
    if(regStep === 1){
        setAlrtMessage("Are you sure you want to go back?")
        setOpen(true)
        
    }else(
      handleStepChange(-1)
  )
 
}
function handleExitSubRej() {
  navigate('/rejectedsubjects')
}




const [medUsedInLast3WeeksRadio, setMedUsedInLast3WeeksRadio] = useState(rejSubj?.medicationUsedInLast3Weeks?.length>0 ? 'yes':'no')
const handleMedUsedInLast3WeeksRadio=(e)=>{
  setMedUsedInLast3WeeksRadio(e.target.value)
  if(e.target.value =='yes'){
    setMedUsedInLast3WeeksDetails (
      rejSubj?.medicationUsedInLast3Weeks === null || rejSubj?.medicationUsedInLast3Weeks === undefined? [{
        "medication_name": "",
        "medication_route": "",
        "dosage":"",
        "frequency": "",
        "current_idx":1
      },]:
      rejSubj?.medicationUsedInLast3Weeks?.map((i, index) => ({
        "subject_medication_used_in_last_3weeks_id": i.subject_medication_used_in_last_3weeks_id||null,
        "dosage":i.dosage,
        "frequency":i.frequency ,
        "medication_name":i.medication_name ,
        "medication_route":i.medication_route ,
        "current_idx":index
       }))   
    )}
  if(e.target.value =='no'){
    setMedUsedInLast3WeeksDetails ([])
    
  
    setMedUsedInLast3WeeksRadio(e.target.value)
  //   if (medicationDetails) {
  //  medicationDetails.forEach(obj => {
  //         for (const key in obj) {
  //           obj[key] ='';  
  //         }
  //       });
  //       setMedicationDetails([...medicationDetails])
  //     }

  }  
}

const handleInputMedicationUsedChange = (index, e) => {
  const { name, value } = e.target;
  const newArray = [...medUsedInLast3WeeksDetails];
  newArray[index][name] = value;
  setMedUsedInLast3WeeksDetails(newArray);
  if(medUsedInLast3WeeksRadio =='no'){
      setMedUsedInLast3WeeksDetails([]);
  }
};


const handleDeleteMedicationUsed =(index) => {
  let updatedData = [...medUsedInLast3WeeksDetails]
  updatedData?.map((elemObj,i)=>{
    if(elemObj.current_idx==index.current_idx){
      updatedData.splice(i,1)
    }
  })

  
  setMedUsedInLast3WeeksDetails(updatedData)
}


let medUsedInLast3WeeksDtlsBtn= medUsedInLast3WeeksDetails?.some(detail => {
  let indx=detail.current_idx;
  delete detail.current_idx;
  let x= !Object.values(detail).every(value => value.length)
  detail.current_idx=indx;
  return x
})

const handleAddMedUsedInLast3WeeksFields = () => {
  setMedUsedInLast3WeeksDetails([...medUsedInLast3WeeksDetails, 
      {
          "medication_name": "",
          "medication_route": "",
          "dosage":"",
          "frequency": "",
          "current_idx":currentIndex+1
      },]);
      setCurrentIndex(currentIndex + 1);
};
let medUsedInLast3WeeksDetailsNew=[];
medUsedInLast3WeeksDetails?.map((elem)=>{
  if(!elem.subject_medication_used_in_last_3weeks_id){
    medUsedInLast3WeeksDetailsNew.push(elem)
  }
})
let updatedObj = {
    "subject_id": rejSubj?.subject_id,
    "subject_dose_id": rejSubj?.subject_dose_id,
    "phone_number":subjPhone,
    "sex":gender,
    "weight":weight,
    "height":height,
    "date_of_birth":firstPgInputs.date_of_birth,
    "allergies": anyAllergies,
    // "medication_used_in_last_3weeks": medicationsUsed,
    "medical_history": medicalHistory,
    "concurrent_illness": ConcurrentIllness,
    "date_of_administration":dateOfAdministration,
    "time_of_administration":timeOfAdministration,
    "batch_number":batchNumber,
    "expiry_date":expiry,
    "date_of_manufacture":dateOfManu,
    "is_concomitant_medication": rejSubj?.concomitantMedication?.length>0? TOGGLE_YES :TOGGLE_NO,
    "concomitant_medication": medicationDetails,
    "subject_medication_used_in_last_3weeks_id":medUsedInLast3WeeksDetails,
    "is_medication_usedinlast3weeks" : medUsedInLast3WeeksRadio ? TOGGLE_YES : TOGGLE_NO || null,
    "medication_usedinlast3weeks":medUsedInLast3WeeksDetails,
    "updated_by":localStorage.login_user_name,

}




  return (
    <>
     <div>
      <NavigationBar
        title={"Edit Subject Details"}
        selectedStudy={selectedStudy}
        studyDropdwn={true}
        btnDisable={btnDisable}
      />
   {/* <PIFlowLeftNavBar /> */}
      <div className="main_body registration_steps_main">
        <div className="row">
          <div
            className="col-lg-3 reg_stps_titlbar"
            style={{
              backgroundColor: "#E2E8F0",
            }}
          >
            <div className="lableSteps regstep_title">
            
              <span className='regstpstxtmbl'>
              <img src="./images/icons/back_arrow.svg" alt="" 
              onClick={handleBackAction}
              className='back_arrowmbl'/>&nbsp; 
              Registration Steps</span>
              <span>{regStep + " of " + registrationSteps.length}</span>
            </div>
            <div className='subj_reg_mbl' style={{ height: "70vh", overflowY: "auto" }}>
              {registrationSteps.map((step, index) => {
                return (
                  <div
                  key={index}
                    className={`${
                      regStep === index + 1 ? "selectedTabStyl" : ""
                    }`}
                  >
                    <div
                      className={`my-div ${
                        regStep === index + 1
                          ? "registration_steps_selected selectdMr"
                          : "registration_steps"
                      }`}
                      key={index}
                    >
                      <span>{step.stepTitle}</span>
                      <span className="registration_description">
                        {step.description}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col">
            <div className="lableContent top-stepper-main subj_reg_mbl">
              <div className="regStepsMain ">
                {registrationSteps.map((item, index) => (
                  <div
                  key={index}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <div
                        className={`${
                          regStep >= index + 1 ? "stageSelected" : "stage"
                        }`}
                      >
                        <span>{index + 1}</span>
                      </div>
                    </div>
                    
                  </div>
                ))}
              </div>
            </div>
      {regStep === 1 && 
        <div className="subject_reg_body">
        <div className='d-flex flex-column m-2 gap-3'>
                    {rejSubj?.comments?.map(i => {
                      
                      const date = new Date(i.createdAt);
                      date.setHours(date.getHours() + 5);
                      date.setMinutes(date.getMinutes() + 30);
                      return (
                        <div className='bordered p-3 border rounded' >


                          <p className="mb-1"><b>Comment :</b> &nbsp; {i.comment}</p>
                          <p className="mb-1"><b>At :</b>&nbsp; {moment(date).format("DD-MM-YYYY hh:mm a")}</p>
                        </div>
                      )
                    })}
  
         </div>
        </div>

}

            {regStep === 2 && (
              <div className="subject_reg_body">
                <div className='row d-flex gap-2 gap-md-4 mt-0 '>
                  <div className="col col-sm-6 col-md-6 col-lg-6">
                    <label htmlFor="mrName">
                      First name 
                    </label>
                    <input
                      value={firstPgInputs.first_name}
                       
                      disabled 
                      name="first_name"
                      className="customInput"
                      id="firstName"
                      type="text"
                      placeholder="First name"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handleFirstPage}
                    />
                  </div>

                  <div className="col">
                    <label htmlFor="lastName">
                      Last name 
                    </label>
                    <input
                      value={rejSubj?.last_name}
                      name="last_name"
                      disabled 
                      className="customInput"
                      id="lastName"
                      type="text"
                      placeholder="Last name"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handleFirstPage}
                    />
                  </div>
                
                    <div className="col col-md-6 col-lg-6  dateOfBirth">
                      <label htmlFor="dateOfBirth">
                        Date of Birth<span className="text-danger">*</span>
                      </label>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <input

                          style={{
                            borderRadius: "6px 0px 0px 6px",
                            padding: "16px 12px",
                            width: "190px",
                            cursor: "not-allowed",
                          }}
                          value={firstPgInputs.date_of_birth}
                          max={moment(maxDateOfBirth).format('YYYY-MM-DD')||minDob}
                          min={moment(minDateOfBirth).format('YYYY-MM-DD')||maxDob}
                          disabled={dsblFrRejSub}
                          name="date_of_birth"
                          className="customInput dateOfBirth"
                          id="dateOfBirth"
                          type="date"
                          aria-placeholder="#D4D4D4"
                          onChange={handleFirstPage}
                          onKeyDown={(e) => e.preventDefault()} // Prevent user input
                        />
                        <input  style={{
                            borderRadius: "0px",
                            padding: "16px 12px",
                            width: "140px",
                          }}
                          value={age}
                          className="ageFieldmbl"
                          id="mrAge"
                          type="number"
                          placeholder="Age"
                          aria-placeholder="#D4D4D4"
                          disabled
                        />
                        <input
                          value={"Yrs"}
                          className="years"
                          id="mrAge"
                          type="text"
                          placeholder="Yrs"
                          aria-placeholder="#D4D4D4"
                          style={{
                            padding: "16px 12px",
                            width: "50px",
                            borderRadius: "0px 8px 8px 0px",
                            backgroundColor: "#F7F9FB",
                          }}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col">
  <label htmlFor="mrGender">
    Sex<span className="text-danger">*</span>
  </label>
  <div style={{ display: "flex", flexDirection: "row" }}>
    {["Male", "Female", "Others"].map((option) => { 
      return(
      <button
        key={option}
        disabled={dsblFrRejSub}
        onClick={() => handleQrGenderChange(option)}
        className={`genderButton ${
          gender === option ? "genderButtonSelected" : ""
        }`}
        style={{
          borderRadius:
            option === "Male"
              ? "6px 0px 0px 6px"
              : option === "Others"
              ? "0px 6px 6px 0px"
              : "0px",
        }}
      >
        {option}
      </button>
    )})}
  </div>
</div>

                 
                 
                 

                  <div className="col-12 col-md-6">
                    <label htmlFor="lastName">
                      Weight<span className="text-danger">*</span>
                    </label>
                    <div style={{ display: "flex" }} className='weight_input'>
                      <input
                        value={weight}
                        disabled={dsblFrRejSub}
                        className=" "
                        name="weight"
                        id="weight"
                        placeholder="Enter weight"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "16px 12px",
                          width: "329px",
                          borderRadius: "8px 0px 0px 8px",
                        }}
                        onChange={handleWeightChange}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^\d\s.]/g, ''); // Allow positive integers, dots, and spaces
                      }}
                      />
                      <input
                        value={"kg"}
                        className=""
                        id="lastName"
                        type="text"
                        placeholder="KG"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "16px 12px",
                          width: "50px",
                          borderRadius: "0px 8px 8px 0px",
                          backgroundColor: "#F7F9FB",
                        }}
                        disabled
                      />
                    </div>
                    {werror && <div style={{ color: 'red' }}>{werror}</div>}
                  </div>

                 
                  {/* <div className="col">
                    <label htmlFor="mrName">Phone<span className="text-danger">*</span> </label>
                    <input
                      value={subjPhone}
                      className="customInput noSpinArrows"
                      name="phone_number"
                      disabled={dsblFrRejSub}
                      id="phone_number"
                      type="number"
                      placeholder="Enter phone number"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handlePhonenumber}
                    />
                    
                    <div className=' ' style={{ color: 'red' }}>{error}</div>
                  </div> */}

           <div className="col">
                    <label htmlFor="phone_number">Phone<span className="text-danger">*</span></label>
                    <div style={{ display: "flex" }} >
                    <input
                        value={"+91"}
                        className=""
                        id="code"
                        type="text"
                        placeholder="+91"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "16px 7px",
                          width: "50px",
                          borderRadius: "8px 0px 0px 8px",
                          backgroundColor: "#F7F9FB",
                        }}
                        disabled
                      />
                    <input
                      value={
                        subjPhone?.length>=10 || subjPhone.length==0?subjPhone.slice(0,10):subjPhone || rejSubj?.phone_number
                      }
                      className="customInput noSpinArrows "
                      name="phone_number"
                      disabled={dsblFrRejSub}
                      id="phone_number"
                      type="number"
                      placeholder="Enter phone number"
                      aria-placeholder="#D4D4D4"
                      
                      style={{ padding: "16px 12px", flex: 1,borderRadius:"0px 8px 8px 0px" }}
                      onChange={handlePhonenumber}
                    />
                    </div>
                    <div className=' ' style={{ color: 'red' }}>{error}</div>
                  </div>
                  <div className="col-12 col-md-6">
                    <label htmlFor="lastName">
                      Height<span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ display: "flex" }} className='weight_input'>
                      <input
                        value={height }
                        disabled={dsblFrRejSub}
                        className=" "
                        name="weight"
                        id="weight"
                        placeholder="Enter height"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "16px 12px",
                          width: "329px",
                          borderRadius: "8px 0px 0px 8px",
                        }}
                        onChange={handleHeightChange}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^\d\s.]/g, ''); // Allow positive integers, dots, and spaces
                      }}
                      />
                      <input
                        value={"cm"}
                        className=""
                        id="lastName"
                        type="text"
                        placeholder="CM"
                        aria-placeholder="#D4D4D4"
                        style={{
                          padding: "16px 12px",
                          width: "52px",
                          borderRadius: "0px 8px 8px 0px",
                          backgroundColor: "#F7F9FB",
                        }}
                        disabled
                      />
                    </div>
                    {error1 && <div style={{ color: 'red' }}>{error1}</div>}
                  </div>

                  <div className="col-12 col-md">
                    <label htmlFor="mrName">Date of enrollment</label>
                    <input
                      value={rejSubj?.date_of_report}
                      className="customInput date_of_report"
                      name="date_of_report"
                      id="date_of_report"
                      type="text"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      disabled
                    />
                  </div>
                  
                  <div className="col-12 col-md-6">
                    <label htmlFor="lastName">
                      BMI
                    </label>
                    <div style={{ display: "flex" }} className=''>
                      <input
                        value={bmi}
                        disabled
                        className="Bmi_input"
                        name="bmi"
                        id="bmi"
                        type="text"
                        placeholder="BMI"
                        aria-placeholder="#D4D4D4"
                        style={{ padding: "16px 12px", width: "380px" }}
                        onChange={handleHeightChange}
                      />
                    </div>
                  </div>

                  
                </div>
                
                </div>
            )}
            
            {regStep === 3 && (
              <div className="subject_reg_body">
                <div className={`row mt-0 gap-3 ${JustBtwn}`}>
                  <div className="col-6 col-lg-5 allergies">
                    <label htmlFor="mrName">
                      Any allergies
                    </label>
                    <input
                      value={anyAllergies}
                      className="customInput"
                      disabled={dsblFrRejSub}
                      id="firstName"
                      type="text"
                      placeholder="Enter here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handleAllergyChange}
                    />
                  </div>

                 
                  <div className="col-6 col-lg-5 allergies">
                    <label htmlFor="mrName">
                    Medical history
                    </label>
                    <input
                      value={medicalHistory}
                      className="customInput"
                      disabled={dsblFrRejSub}
                      id="firstName"
                      type="text"
                      placeholder="Enter here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handleMedicalHistoryChange}
                    />
                  </div>

                  <div className="col-6 col-lg-5 allergies">
                    <label htmlFor="lastName">
                      Concurrent illness(if any) specify
                    </label>
                    <input
                      value={ConcurrentIllness}
                      className="customInput"
                      id="lastName"
                      disabled={dsblFrRejSub}
                      type="text"
                      placeholder="Enter here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handleConcurrentIllnessChange}
                    />
                  </div>

                    <div>
                  {<div className="">
                    <label htmlFor="mrName">
                      Any medication used in last 3 weeks?
                    </label>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="radio"
                          value="yes"
                          disabled={dsblFrRejSub}
                          checked={medUsedInLast3WeeksRadio === "yes"}
                          onChange={handleMedUsedInLast3WeeksRadio}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>Yes</span>
                      </label>

                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <input
                          type="radio"
                          value="no"
                          disabled={dsblFrRejSub}
                          checked={medUsedInLast3WeeksRadio === "no"}
                          onChange={handleMedUsedInLast3WeeksRadio}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>No</span>
                      </label>
                    </div>
                  </div>}
                </div>
                { medUsedInLast3WeeksRadio === "yes" && (
                  <div className="concomitant_container">
                    <Row className="mt-0 ps-2 ps-md-0">
                      {medUsedInLast3WeeksDetails?.map((input, index) => (
                        <div
                          key={input.id}
                          className="position-relative concomitant_detials px-3 mt-4"
                        >
                          {index !== -1 && (
                            <button
                              onClick={() => handleDeleteMedicationUsed(input, index)}
                              className="cross_btn"
                            >
                              <span>x</span>
                            </button>
                          )}

                          <div className='d-lg-flex  justify-content-between gap-5 '>
                          <InputComponent
                              type="text"
                              width={"320px"}
                              label={"Medication"}
                              required={'*'}
                              fontWeight={600}
                              disabled={dsblFrRejSub}
                              placeholder={"Enter Medication Details"}
                              name="medication_name"
                              value={input.medication_name}
                              onChange={(e) => handleInputMedicationUsedChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              required={'*'}
                              fontWeight={600}
                              disabled={dsblFrRejSub}
                              width={"320px"}
                              label={"Route/Site"}
                              name="medication_route"
                              placeholder={"Enter Route/Site Details"}
                              value={input.medication_route}
                              onChange={(e) => handleInputMedicationUsedChange(index, e)}
                            />
                          </div>
                          <div className='d-lg-flex  justify-content-between gap-5 '>
                            <InputComponent
                            required={'*'}
                              type="text"
                              fontWeight={600}
                              disabled={dsblFrRejSub}
                              width={"320px"}
                              placeholder={"Enter Dosage"}
                              label={"Dosage"}
                              name="dosage"
                              value={input.dosage}
                              onChange={(e) => handleInputMedicationUsedChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              required={'*'}
                              fontWeight={600}
                              disabled={dsblFrRejSub}
                              width={"320px"}
                              label={"Frequency"}
                              name="frequency"
                              placeholder={"Enter Frequency"}
                              value={input.frequency}
                              onChange={(e) => handleInputMedicationUsedChange(index, e)}
                            />
                          </div> 
                        </div>
                      ))}
                    </Row>
                    {!medUsedInLast3WeeksDtlsBtn && <div className="addBtn">
                      <button
                        className="white_btn px-4 mt-3"
                        onClick={handleAddMedUsedInLast3WeeksFields}
                      >
                        Add
                      </button>
                    </div>}
                  </div>
                )}


                 
                </div>
               </div>
               
            )}
            {regStep === 4 && (
              <div className="subject_reg_body">
                <div className='row d-flex gap-3 mt-0'>
                  <div className="col">
                    <label htmlFor="mrName">
                      Name of the study
                    </label>
                    <input
                      value={study} 
                      className="customInput"
                      disabled
                      id="firstName"
                      type="text"
                      placeholder="Enter study name"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handleStudyChange}
                    />
                  </div>

                  <div className="col ">
                    <label htmlFor="dose">
                      Dose
                    </label>
                    <input
                      name="dose"
                      id="piStudy"
                      className="selectTag-subj subj_dose_input"
                      style={{ width: "380px" }}
                      value={`D${dose}`}
                      disabled
                      // onChange={handleDoseChange}
                    />
                      {/* <option>Select</option>
                      {dosesArray &&
                        dosesArray.map((dose) => (
                          <option key={dose} value={dose}>
                            Dose {dose}
                          </option>
                        ))}*/}
                  </div>
               
                 
                  <div className="col-12 col-lg col-md">
                    <label htmlFor="Rout of Administration">
                      Route of administration
                    </label>
                    {/* <select id='piStudy' className='selectTag'  style={{width:"380px"}} value={route}>
                                        <option>Oral</option>
                                    </select> */}
                    <input
                      value={routeOfAdministration}
                      className="customInput"
                      id="Rout of Administration"
                      type="text"
                      placeholder=""
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handleStudyChange}
                      disabled
                    />
                  </div>
                  <div className="col col-12 col-lg col-md">
                    <label htmlFor="lastName">
                      Anatomical site of administration
                      {/* <span style={{ color: "red" }}>*</span> */}
                    </label>
                    {/* <select id='piStudy' className='selectTag'  style={{width:"380px"}} value={anatomical} >
                                        <option>Mouth</option>
                                    </select> */}
                    <input
                      value={anatomical}
                      className="customInput"
                      id="Anatomical"
                      type="text"
                      placeholder=""
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handleStudyChange}
                      disabled
                    />
                  </div>
                 
                  <div className="col">
                    <label htmlFor="mrName">
                      Date of administration
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      value={dateOfAdministration}
                      className="customInput"
                      id="firstName"
                      // disabled={dsblFrRejSub}
                      disabled
                      type="date"
                      placeholder="Enter here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px",cursor: "not-allowed" }}
                      onChange={handleDateOfAdministrationChange}
                      onKeyDown={(e) => e.preventDefault()}
                      max={moment().format("YYYY-MM-DD")}
                      min={minxDate}
                    />
                    {dateOfAdministration?null:
                          <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                          }
                  </div>

                  <div className="col-12 col-lg col-md">
                    <label htmlFor="lastName">
                      Time of administration (24 hrs)<span className="text-danger">*</span>
                       
                    </label>
                    <input
                      value={timeOfAdministration}
                      className="customInput"
                      id="lastName"
                      type="time"
                      // disabled={dsblFrRejSub}
                      disabled
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handleTimeOfAdministrationChange}
                    />
                    {timeOfAdministration?null:
                          <span className="placeholder-span" style={{width:"40px", height:"22px"}}>--:--</span>
                          }
                  </div>
                 
                  <div className="col">
                    <label htmlFor="mrName">
                      Batch number<span className="text-danger">*</span>
                    </label>
                    <input
                      value={batchNumber}
                      className="customInput"
                      id="firstName"
                      type="text"
                      placeholder="Enter Here"
                      disabled={dsblFrRejSub}
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handleBatchNumberChange}
                    />
                  </div>

                  <div className="col">
                    <label htmlFor="mrName">
                      Date of manufacture<span className="text-danger">*</span>
                    </label>
                    <input
                      value={dateOfManu}
                      className="customInput"
                      id="firstName"
                      disabled={dsblFrRejSub}
                      type="date"
                      max={maxDate}
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px",cursor: "not-allowed" }}
                      onChange={handleDateOfManuChange}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    {dateOfManu?null:
                          <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                          }
                  </div>
                
                  </div>

                 
                 

                  <div className="col">
                    <label htmlFor="lastName">
                      Expiry date<span className="text-danger">*</span>
                    </label>
                    <input
                      value={expiry}
                      className="customInput"
                      id="lastName"
                      type="date"
                      min={moment(today).format('YYYY-MM-DD')}
                      disabled={dsblFrRejSub}
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" ,cursor: "not-allowed"}}
                      onChange={handleExpiryChange}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                    {expiry?null:
                          <span className="placeholder-span" style={{width:"120px", height:"22px"}}>dd-mm-yyyy</span>
                          }
                  </div>
                 
                {/* <div>
                  <div className="">
                    <label htmlFor="mrName">
                      Any adverse event within <b style={{color:"red"}}>{optedStudy?.immediate_adverse_event}</b>  min, post vaccination?
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <input
                          type="radio"
                          className="C-pointer"
                          value="yes"
                          checked={selectedOption === "yes"}
                          onChange={handleOptionChange}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>Yes</span>
                      </label>

                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <input
                          type="radio"
                          className="C-pointer"
                          value="no"
                          checked={selectedOption === "no"}
                          onChange={handleOptionChange}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>No</span>
                      </label>
                    </div>
                  </div>
                </div> */}
              </div>
            )}
           
            {regStep === 5 && (
              <div className="subject_reg_body">
                <div className="center-container">
                  <div className="">
                    <label htmlFor="mrName">
                      Concomitant medication administered at the same time, as
                      applicable
                    </label>                  
                    {/* <div style={{ display: "flex", flexDirection: "row" }}>
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="radio"
                          value="yes"
                          checked={concomitantRadio === "yes"}
                          onChange={handleConcomitantRadio}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>Yes</span>
                      </label>

                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <input
                          type="radio"
                          value="no"
                          checked={concomitantRadio === "no"}
                          onChange={handleConcomitantRadio}
                          style={{ width: "20px" }}
                        />
                        <span style={{ marginLeft: "10px" }}>No</span>
                      </label>
                    </div> */}
                  </div>
                  {!medicationDtlsBtn && !dsblFrRejSub &&<div className="addBtn">
                      <button
                        className="white_btn px-4"
                        onClick={handleAddFields}
                      >
                        Add
                      </button>
                    </div>}
                </div>
                 
                  <div className="concomitant_container">
                    <Row className="mt-0 ps-2 ps-md-0">
                      {medicationDetails?.map((input, index) => (
                        <div
                          key={input.concomitant_medication_id}
                          className="position-relative concomitant_detials px-3"
                        >
                          {index !== -1 && (
                            <button
                              onClick={() => handleDeleteFields(input, index)}
                              className="cross_btn" 
                              disabled={dsblFrRejSub}
                            >
                              <span 
                              disabled={dsblFrRejSub}
                              >x</span>
                            </button>
                          )}


                          {/* <Col md={5} className="d-flex flex-column">
                            <InputComponent
                              type="text"
                              width={"320px"}
                              label={"Medication"}
                              disabled={dsblFrRejSub}
                              fontWeight={600}
                              placeholder={"Enter Medication Details"}
                              name="medication"
                              value={input.medication}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              width={"320px"}
                              fontWeight={600}
                              disabled={dsblFrRejSub}
                              label={"Manufacturer"}
                              placeholder={"Enter Manufacturer Details"}
                              name="medication_manufacturer"
                              value={input.medication_manufacturer}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </Col>
                          <Col md={5} className="d-flex flex-column">
                            <InputComponent
                              type="text"
                              fontWeight={600}
                              disabled={dsblFrRejSub}
                              width={"320px"}
                              placeholder={"Enter Batch Number"}
                              label={"Batch Number"}
                              name="medication_batch_number"
                              value={input.medication_batch_number}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              fontWeight={600}
                              width={"320px"}
                              disabled={dsblFrRejSub}
                              label={"Route/Site"}
                              name="medication_route_site"
                              placeholder={"Enter Route/Site Details"}
                              value={input.medication_route_site}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </Col> */}

<div className='d-lg-flex  justify-content-between gap-5 '>
<InputComponent
                              type="text"
                              width={"320px"}
                              label={"Medication"}
                              disabled={dsblFrRejSub}
                              fontWeight={600}
                              placeholder={"Enter Medication Details"}
                              name="medication"
                              value={input.medication}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              width={"320px"}
                              fontWeight={600}
                              disabled={dsblFrRejSub}
                              label={"Manufacturer"}
                              placeholder={"Enter Manufacturer Details"}
                              name="medication_manufacturer"
                              value={input.medication_manufacturer}
                              onChange={(e) => handleInputChange(index, e)}
                            />

                          </div>

                         <div className='d-lg-flex  justify-content-between gap-5 '>
                         <InputComponent
                              type="text"
                              fontWeight={600}
                              disabled={dsblFrRejSub}
                              width={"320px"}
                              placeholder={"Enter Batch Number"}
                              label={"Batch Number"}
                              name="medication_batch_number"
                              value={input.medication_batch_number}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              fontWeight={600}
                              width={"320px"}
                              disabled={dsblFrRejSub}
                              label={"Route/Site"}
                              name="medication_route_site"
                              placeholder={"Enter Route/Site Details"}
                              value={input.medication_route_site}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </div>

                          <div className='d-lg-flex  justify-content-between gap-5 '>
                            <InputComponent
                              type="text"
                              fontWeight={600}
                              width={"320px"}
                              disabled={dsblFrRejSub}
                              placeholder={"Enter Dosage"}
                              label={"Dosage"}
                              name="medication_dosage"
                              value={input.medication_dosage}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                            <InputComponent
                              type="text"
                              disabled={dsblFrRejSub}
                              fontWeight={600}
                              width={"320px"}
                              label={"Frequency"}
                              name="medication_frequency"
                              placeholder={"Enter Frequency"}
                              value={input.medication_frequency}
                              onChange={(e) => handleInputChange(index, e)}
                            />
                          </div> 
                        </div>
                      ))}
                    </Row>
                    {/* {!medicationDtlsBtn && !dsblFrRejSub &&<div className="addBtn">
                      <button
                        className="white_btn px-4"
                        onClick={handleAddFields}
                      >
                        Add
                      </button>
                    </div>} */}
                  </div>
                 
              </div>
            )}
            {regStep === 6 && (
              <div className="subject_reg_body">
                <div className= 'row  d-flex justify-content-center justify-content-md-between gap-3 gap-md-3 gap-xxl-5 mt-2'>
                  <div className="card viewCardStyl col-5 ps-1" >
                    <div className="card-header cardHeading">
                      <h6>Subject Details</h6>
                    </div>
                    <div className="table-responsive body ">
                      <table className="table card_columns_styl border-0">
                        <tbody>
                          <tr>
                            <td>Subject Name</td>
                            <td style={{ minWidth: "14rem" }}>{firstPgInputs.first_name} {firstPgInputs.last_name}</td>
                          </tr>
                          <tr>
                            <td>Age</td>
                            <td>{age}</td>
                          </tr>
                          <tr>
                            <td>Mobile</td>
                            <td>{subjPhone}</td>
                          </tr>
                          <tr>
                            <td>Gender</td>
                            <td>{gender}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                 


                  <div className="card viewCardStyl  col ps-1" >
                    <div className="card-header cardHeading">
                      <h6>Study Details</h6>
                    </div>
                    <div className=" cardBody ">
                      <div className="table-responsive body w-100">
                        <table className="table card_columns_styl border-0">
                          <tbody>
                            <tr>
                              <td>Study Name</td>
                              <td>{rejSubj?.study_name ? (rejSubj?.study_name.length > 25 ? rejSubj?.study_name.slice(0, 25) + "..." : rejSubj?.study_name) :"-"}</td>
                            </tr>
                            <tr>
                              <td>Route of administration</td>
                              <td>{rejSubj?.dose_administration_name ? rejSubj?.dose_administration_name :"-"}</td>
                            </tr>
                            <tr>
                              <td>Batch No.</td>
                              <td>{batchNumber ? batchNumber :"-"}</td>
                            </tr>
                            <tr>
                              <td>Date of Administration</td>
                              <td>{moment(dateOfAdministration || today).format("DD-MM-YYYY")}</td>
                            </tr>
                            <tr>
                              <td>Expiry Date</td>
                              <td>{moment(expiry).format("DD-MM-YYYY")}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                 
 
</div>
<div className="row mt-0">

  <div className="card viewCardStyl col ps-1">
  <div className="card-header cardHeading w-100">
    <h6>Past Health History</h6>
  </div>
  <div className="table-responsive body">
    {anyAllergies || medicalHistory || ConcurrentIllness !== '' ? (
      <table className="table card_columns_styl border-0">
        <tbody>
          <tr>
            <td>Allergies</td>
            <td>{anyAllergies}</td>
          </tr>
          <tr>
            <td>Medical History</td>
            <td>{medicalHistory}</td>
          </tr>
          <tr>
            <td>Illness</td>
            <td>{ConcurrentIllness === '' ? '' : ConcurrentIllness}</td>
          </tr>
        </tbody>
      </table>
    ) : (
      <div className="concomitantMsg">
        <p >No Past Health History</p>
      </div>
    )}
  </div>
</div>

</div>
<div className="row mt-0">

  <div className="card viewCardStyl col ps-1">
  <div className="card-header cardHeading">
    <h6>Concomitant Medication</h6>
  </div>
  <div className="cardBody centered-container">
    {medicationDetails && medicationDetails.length > 0 ? (
      <div className="body Concon_medication_main w-100">
        <table className="table Concon_medication">
          <thead>
            <tr>
              <th scope="col">Medication</th>
              <th scope="col">Batch Number</th>
              <th scope="col">Manufacturer</th>
              <th scope="col">Route/Site</th>
              <th scope="col">Dosage</th>
              <th scope="col">Frequency</th>
            </tr>
          </thead>
          <tbody>
            {medicationDetails.map((i, index) => {
              return (
                <tr key={index} className="text-start">
                  <td>{i.medication}</td>
                  <td>{i.medication_batch_number}</td>
                  <td>{i.medication_manufacturer}</td>
                  <td>{i.medication_route_site}</td>
                  <td>{i.medication_dosage}</td>
                  <td>{i.medication_frequency}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    ) : (
      <div className="concomitantMsg">
        <p>No Concomitant Medication</p>
      </div>
    )}
  </div>
</div>

</div>
<div className="row mt-0">

  <div className="card viewCardStyl  col ps-1">
  <div className="card-header cardHeading">
    <h6>Any Medication Used  in Last 3 Weeks</h6>
  </div>
  <div className="cardBody">
    {medUsedInLast3WeeksDetails && medUsedInLast3WeeksDetails.length > 0 ?(
      <div className="body Concon_medication_main w-100">
        <table className="table Concon_medication">
          <thead>
            <tr>
              <th scope="col">Medication</th>
              <th scope="col">Route/Site</th>
              <th scope="col">Dosage</th>
              <th scope="col">Frequency</th>
            </tr>
          </thead>
          <tbody>
            {medUsedInLast3WeeksDetails.map((i, index) => {
              
              return (
                <tr key={index} className="text-start">
                  <td>{i.medication_name}</td>
                  <td>{i.medication_route}</td>
                  <td>{i.dosage}</td>
                  <td>{i.frequency}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    ) : (
      <div className="concomitantMsg">
        <p>No Medication is used in Last 3 weeks</p>
      </div>
    )}
  </div>
</div>

</div>
 </div>             
            )}

            <div className="registrationStepsFooter">
            {regStep === 1 && (
                <button
                  className="white_btn btn_styl_mbl px-md-4 "
                  onClick={handleExitSubRej}
                >
                  Exit
                </button>
              )}
              
              {regStep > 1 && (
                <button
                  className="white_btn btn_styl_mbl px-3"
                  onClick={() => handleStepChange(-1)}
                >
                  Previous
                </button>
              )}
             {regStep >1 && (!cancelBtn   ?  <button
                  className="gray_btn  btn_styl_mbl px-md-4"
                  onClick={handleEditFields}
                >
                  Edit
                </button>:
                <button
                  className="gray_btn px-3 btn_styl_mbl"
                  onClick={handleCancelFields}
                >
                  Cancel
                </button>)
                }
              {regStep === 2 && (
                <button
                  disabled={
                     phoneValidation || weight ==''}
                  className={`${next} btn_styl_mbl `}
                  onClick={handleNavigateNext}
                >
                  Next
                </button>
              )}
              {regStep === 1 && (
                <button
                  className={`${next} btn_styl_mbl `}
                  onClick={handleNavigateNext}
                >
                  Next
                </button>
              )}
              

              {regStep === 3 && (
                <button
                  className={`${next} btn_styl_mbl `}
                  onClick={() => handleStepChange(1)}
                >
                  Next
                </button>
              )}
              {regStep === 4 && (
                <button
                  className={`${next} btn_styl_mbl `}
                  onClick={() => handleStepChange(1)}
                  disabled={!(batchNumber!==''&&dateOfManu!=='' &&expiry!=='' && timeOfAdministration!=='')}
                >
                  Next
                </button>
              )}
              {regStep === 5 && (
                <button
                  className={`${next} btn_styl_mbl `}
                  onClick={ () => handleStepChange(1) }
//                   disabled={
//   selectedOption==='no' ? false:
// toggleSAE && seriousAE!=='' && aEClassification!=='' &&eventDesc!==undefined && inputTextNotes !=='' && fifthDisable?false:
//  !toggleSAE &&  aEClassification!=='' && eventDesc!==undefined && eventDesc!=='' &&inputTextNotes !=='' && fifthDisable?false:
// !toggleSAE &&  aEClassification!=='' && valuForDisble!==undefined && fifthDisable?false:
// toggleSAE&& seriousAE!==''&& valuForDisble !== undefined&& aEClassification!==''&& eventDesc!==undefined && fifthDisable?false:
// toggleSAE&& seriousAE!==''&& inputTextNotes !==''&& aEClassification!==''&& eventDesc!==undefined && fifthDisable?false:
// true
//                   }
                >
                  Next
                </button>
              )}

                 
               
              {regStep === 6 && (
                <button disabled={isbtnDisabled || !cancelBtn} className="orange_btn btn_styl_mbl px-3" onClick={handelSubjectCreate}>
                  Update
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <PopUpAlert
      handleClose={handleClosePopup}
      open={open}
    //   title={""}
      msg={alertMessage}
      close={"Cancel"}
      actionbtn={"Sure"}
      onConfirm={handleReviewActions}
  />
   <PopUpModal
          handleClose={handleDonePopup}
          open={openModal}
          title={"Success!"}
          msg={"Details Updated Successfully!"}
          close={"Close"}
          actionbtn={"Done"}
          onConfirm={handleModalConfirm}
        />
    </div>
     {loading && <Loader />}
    </>

   
  );
}

